var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "select-options",
    _vm._g(
      _vm._b(
        {
          ref: "select",
          attrs: {
            name: _vm.name,
            options: _vm.options,
            loading: _vm.loadingGroups
          }
        },
        "select-options",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }